import { useSelector } from 'react-redux';
import { AppState } from '../../../global/redux/store';
import { Roles } from '../../../shared/enums/Roles';

export const useIsInRole = (roles: Roles[]): boolean => {
  const userRoles = useSelector((state: AppState) => state.currentUser.user?.Roles);
  return userRoles !== undefined && userRoles.filter((value) => roles.includes(value)).length > 0;
};
